// extracted by mini-css-extract-plugin
module.exports =  {"StatsContainer":"StatsContainer__2-MOb","NewFeaturePromo":"NewFeaturePromo__r0NRS","filterNote":"filterNote__rtVH4"};